import { createSelector } from '@ngrx/store';

import { getCart } from '@shared/state/cart/selectors';
import { getCurrentLocationNo } from '@shared/state/currentLocation/selectors';
import { getCartSimpleItemQuantity } from '../getCartSimpleItemQuantity';

export const getCartSimpleProductTotalQuantityForCurrentLocation = (productId: number, virtualLocationNo?: number) =>
    createSelector(getCart, getCartSimpleItemQuantity(productId, virtualLocationNo), getCurrentLocationNo, (cart, total, currentLocation) => {
        if (!cart || !cart.locationNo || !currentLocation || cart.locationNo !== currentLocation) return null;

        return total;
    });
